/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { FormControl, FormControlLabel, FormLabel, RadioGroup, Radio } from '@mui/material';
import { CustomStack } from 'modules/common/components';
import BookingDatePicker from 'modules/transactions/components/inner-filter/components/booking-date-picker';
import styles from 'modules/transactions/components/inner-filter/inner-filter.module.scss';
/**
 * Booking window component common for the dashboard component
 * @param {Boolean} vOTB - State to enable custom booking
 * @param {Boolean} customBooking - State to enable custom booking
 * @param {Boolean} handleOTBChange - Function to call when the radio button selection changes
 * @param {Date} latestDate - Latest date value
 * @param {*} otbValue - OTB value
 * @returns
 */
const BookingWindow = ({ vOTB, customBooking, handleOTBChange, latestDate, otbValue, id = '' }) => (
  <CustomStack cssClassName={styles.innerFilter}>
    <FormControl>
      <FormLabel>Booking Window</FormLabel>
      <RadioGroup value={vOTB} name="radio-buttons-group" onChange={handleOTBChange}>
        <FormControlLabel
          sx={{
            my: -1,
          }}
          value={otbValue}
          control={<Radio />}
          label="OTB"
          id={`${id}-otb`}
        />
        <FormControlLabel
          sx={{
            my: -1,
          }}
          value
          control={<Radio />}
          label="Custom Booking Window"
          id={`${id}-custom-window`}
        />
      </RadioGroup>
    </FormControl>
    {customBooking && <BookingDatePicker latestDate={latestDate} id={`${id}-date-picker`} />}
  </CustomStack>
);
//
export default BookingWindow;
